'use client'

import React from 'react'

import type { PromotionOfferDetailsData } from '@/lib/promotions/promotionCard'
import { useMessages } from '@/lib/i18n/useMessages'
import { cn } from '@/utilities/ui'

type PromotionCardOfferDetailsProps = {
  details: PromotionOfferDetailsData
}

export function PromotionCardOfferDetails({ details }: PromotionCardOfferDetailsProps) {
  const messages = useMessages()
  const labels = messages.promotions.offerDetails

  const items = [
    { label: labels.bookingWindow, value: details.bookingWindow },
    { label: labels.moveIn, value: details.moveIn },
    { label: labels.minimumStay, value: details.minimumStay },
  ].filter((item): item is { label: string; value: string } => Boolean(item.value))

  if (items.length === 0) {
    return null
  }

  return (
    <dl
      className={cn(
        'grid gap-2',
        items.length === 1 && 'grid-cols-1',
        items.length === 2 && 'grid-cols-2',
        items.length === 3 && 'grid-cols-3',
      )}
    >
      {items.map((item) => (
        <div
          className="flex min-w-0 flex-col gap-1 rounded-[22px] bg-[#FFE8D6] p-4"
          key={item.label}
        >
          <dt className="font-outfit text-base font-medium text-[#400000]">{item.label}</dt>
          <dd className="font-outfit text-base font-semibold text-[#400000]">{item.value}</dd>
        </div>
      ))}
    </dl>
  )
}
